import State from "Types/creditApp";
import baseReducer from "./base";

const creditApp = (state: any = {}, action: any): State => ({
    base: baseReducer(state.base, action, state),
});

export default creditApp;
